import { ScatterplotLayer } from '@deck.gl/layers';
import { area, length } from '@turf/turf';


export const mouseMove = (setCurrentCoordinate, event, activeMode, snapToVertex, wfsLayers, setSnappedVertex, setSnapLayer) => {
    setCurrentCoordinate(event.coordinate);
    try {
        if (activeMode !== null) {
            if (event.coordinate) {
                let nearestVertex = snapToVertex(event.coordinate, wfsLayers, 1);
                if (nearestVertex !== event.coordinate) {
                    setSnappedVertex(nearestVertex);
                    const pointData = [
                        {
                            position: nearestVertex,
                            color: [0, 255, 255, 255]
                        }
                    ];
                    setSnapLayer(new ScatterplotLayer({
                        id: 'point-layer',
                        data: pointData,
                        getPosition: d => d.position,
                        getFillColor: d => d.color,
                        getLineColor: [255, 255, 255],
                        filled: true,
                        getRadius: 8, // jasno vidljiva veličina
                        radiusMinPixels: 8,
                        radiusMaxPixels: 12,
                        getLineWidth: 1,
                        lineWidthMinPixels: 1,
                        stroked: true,
                        pickable: true
                    }));
                } else {
                    setSnapLayer(null);
                    setSnappedVertex(event.coordinate);
                }
            }
        }
    } catch (error) {

    }
};

export const rightClick = (activeMode, currentMeasureDrawing, setMeasurementResult, setActiveMode) => {
    if (activeMode === 'measureArea' && currentMeasureDrawing.length > 2) {
        const polygon = {
            type: 'Feature',
            geometry: {
                type: 'Polygon',
                coordinates: [[...currentMeasureDrawing, currentMeasureDrawing[0]]]
            }
        };
        const ar = area(polygon);
        setMeasurementResult(`Površina: ${ar.toFixed(3)} m²`);
    } else if (activeMode === 'measureDistance' && currentMeasureDrawing.length > 1) {
        const lineString = {
            type: 'Feature',
            geometry: {
                type: 'LineString',
                coordinates: currentMeasureDrawing
            }
        };
        const distance = length(lineString, { units: 'meters' });
        setMeasurementResult(`Dužina: ${distance.toFixed(3)} m`);
    }
    setActiveMode(null);
};
